import {
    Dialog,
    DialogActions,
    DialogContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead
} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {FormattedMessage} from "react-intl";
import React, {useEffect, useState} from "react";
import {getAllElementBox} from "../../../reducers/Box/BoxReducer";
import {shedAction, ShedAudit} from "../../../reducers/Shed/ShedReducer";
import {useAppDispatch, useAppSelector} from "../../../reducers/hooks";
import {dogAction, DogAudit, getAllElement} from "../../../reducers/Dog/DogReducer";
import Paper from "@mui/material/Paper";
import TableRow from "@mui/material/TableRow";
import {ColumnFiltersState} from "@tanstack/react-table";

interface ViewShedModalProps {
    open: boolean;
    onClose: () => void;
    dogData: string | undefined;
    pageableData?: {
        page: number;
        rowsPerPage: number;
        filters: ColumnFiltersState | null;
    };
}

export default function ViewDogModal({
                                         open,
                                         onClose,
                                         dogData,
                                         pageableData
                                     }: ViewShedModalProps) {

    const [details, setDetails] = useState<DogAudit | null>(null); // Stato per i dettagli dello shed
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const dogAudits = useAppSelector((state) => state.DogElement.currentDogAudit);


    const dispatch = useAppDispatch();

    useEffect(() => {
        if (dogData) {
            dispatch(dogAction(dogData));
        }
    }, [dogData, open]);

    const handleClose = () => {
        if (pageableData) {
            const { page, rowsPerPage, filters } = pageableData;
            dispatch(getAllElement({
                pageableDto: {
                    page,
                    size: rowsPerPage,
                    sort: ['dateCreated', 'desc']
                },
                filters
            }));
        }
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
            <DialogTitle>
                <Typography variant="h6"><FormattedMessage id="Action Dog" defaultMessage="Action Dog"/></Typography>
            </DialogTitle>
            <DialogContent>
                {loading ? (
                    <Typography variant="body1">Loading...</Typography>
                ) : dogAudits.length <= 0 ? (
                    <Typography variant="body1">
                        <FormattedMessage id="No data found" defaultMessage="No data found"/>

                    </Typography>
                ) : (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><FormattedMessage id="Action" defaultMessage="Action"/></TableCell>
                                    <TableCell><FormattedMessage id="Old Value" defaultMessage="Old Value"/></TableCell>
                                    <TableCell><FormattedMessage id="New Value"
                                                                 defaultMessage="Action Shed"/></TableCell>
                                    <TableCell><FormattedMessage id="Timestamp" defaultMessage="Timestamp"/></TableCell>
                                    {/*<TableCell>Username</TableCell>*/}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dogAudits.map((audit: DogAudit, index: number) => (
                                    <TableRow key={index}>
                                        <TableCell>{audit.action}</TableCell>
                                        <TableCell>
                                            {audit.oldValue ?
                                                `Box: ${audit.oldValue.name} ${audit.oldValue.shedName}` :
                                                'N/A'
                                            }
                                        </TableCell>
                                        <TableCell>
                                            {audit.newValue ?
                                                `Box: ${audit.newValue?.name} ${audit.newValue?.shedName}` :
                                                'N/A'
                                            }
                                        </TableCell>
                                        <TableCell>
                                            {audit.timestamp
                                                ? new Date(audit.timestamp as unknown as string).toLocaleString()
                                                : 'N/A'
                                            }
                                        </TableCell>
                                        {/*<TableCell>{audit.username}</TableCell>*/}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary" variant="contained">
                    <FormattedMessage id="Close" defaultMessage="Close"/>
                </Button>
            </DialogActions>
        </Dialog>
    );
}
